import { render, staticRenderFns } from "./RegistrationUserComponent.vue?vue&type=template&id=1244f052"
import script from "./RegistrationUserComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationUserComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports